<template>
  <div class="page-report">
    <img src="@/assets/images/journey/banner_journey@2x.png" class="img-cover" alt="" />
    <div class="block-info">
      <div class="title">基础信息</div>
      <div class="block-con">
        <div class="con-info" v-if="
          cur_state &&
          (cur_state.journeyNo === 'C' || cur_state.journeyNo === 'D')
        ">
          <div class="label">带教实操次数：</div>
          <div class="val">
            推荐20次专家带教后可独立操作，当前已完成{{
              cur_state.journeyNo === 'D'
              ? detail.caseVolNonAf
              : detail.caseVolAf
            }}次带教
          </div>
        </div>
        <div class="con-info">
          <div class="label">病例复盘次数：</div>
          <div class="val border">{{ detail.caseReViewCnt ? detail.caseReViewCnt : 0 }}</div>
        </div>
        <div class="con-info">
          <div class="label">模拟器练习次数：</div>
          <div class="val border">{{ detail && detail.casePracticeCnt }}</div>
        </div>
        <div class="con-info">
          <div class="label">理论课程学习时长：</div>
          <div class="val border">{{ detail && detail.courseStudyHour }}h</div>
        </div>
        <div class="con-info">
          <div class="label">参与学术活动次数：</div>
          <div class="val border">{{ detail && detail.caseActivityCnt }}</div>
        </div>
      </div>
    </div>
    <div class="block-flex">
      <div class="flex-nav" v-for="(item, index) in detail.journeyReports" :key="index" @click="handleChangeJounery(item)"
        :class="
          item.journeyName === detail.currentJourneyStage.journeyName
            ? 'cur'
            : ''
        ">
        <img src="@/assets/images/journey/btn_bg_s.png" class="nav-tag-img" v-if="
          item.learningStatus === '2' &&
          item.journeyName === detail.currentJourneyStage.journeyName
        " alt="" />
        <img src="@/assets/images/journey/state_s@2x.png" class="nav-tag-img" v-else-if="item.learningStatus === '2'"
          alt="" />
        <img src="@/assets/images/journey/state_n@2x.png" class="nav-tag-img" v-if="item.learningStatus === '3'" alt="" />
        <img src="@/assets/images/journey/btn_bg_s@2x.png"
          v-if="item.journeyName === detail.currentJourneyStage.journeyName" class="bg-img" alt="" />
        <img src="@/assets/images/journey/btn_bg_n@2x.png" class="bg-img" v-else alt="" />
        <img src="@/assets/images/journey/state_s@2x_1.png" class="nav-tag-img" v-if="item.learningStatus === '1'"
          alt="" />
        <div class="txt">{{ item && item.journeyName }}</div>
      </div>
    </div>
    <div class="block-info block-level">
      <div class="title" v-if="detail && detail.currentJourneyStage">
        {{ detail && detail.currentJourneyStage.journeyName }}
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item class="level-item" v-for="(item, index) in curJourneyDetail.stages" :key="index" :class="
          detail.currentJourneyStage.currentStage &&
            item.stageName === detail.currentJourneyStage.currentStage.stageName
            ? 'cur_level'
            : ''
        " :name="index">
          <template #title>
            <div class="col-title">
              <img src="@/assets/images/journey/report_tab_current@2x.png" v-if="item.learningStatus === '2'"
                class="report-img" alt="" />
              <img src="@/assets/images/journey/report_tab_n@2x.png" v-if="item.learningStatus === '3'" class="report-img"
                alt="" />
              <img src="@/assets/images/journey/report_tab_Passed@2x.png" v-if="item.learningStatus === '1'"
                class="report-img" alt="" />
              <div class="state-name">{{ item.stageNo.substring(0, 2) === 'U4' ? 'U3' : item.stageNo.substring(0, 2) }}</div>
              <div class="state-title">{{ item && item.stageName }}</div>
            </div>
          </template>
          <div class="tip">
            推荐成长周期:{{ Math.ceil(item.growthCycle / 30) }}M
            <div class="delay-day" v-if="item.delayDay > 0 && item.learningStatus === '2'">
              <img src="@/assets/images/journey/time@2x.png" class="icon-time" alt="" />
              已延迟：{{ item.delayDay }}天
            </div>
            <div class="delay-day" v-if="item.learningStatus === '1' && item.endTime">
              过关日期：{{ item.endTime.substring(0, 10) }}
            </div>
          </div>
          <div class="level-title">
            <div class="level-txt">
              <img src="@/assets/images/journey/report_tab_standard@2x.png" class="img-txt" alt="" />
            </div>
            {{ item.evaluationCriteria }}
          </div>
          <van-collapse class="level-course" v-model="activeCourse">
            <van-collapse-item title="模拟器练习" v-if="item.stageTask2 && item.stageTask2.length > 0"
              :name="`${item.stageName}模拟器练习${index}`">
              <van-checkbox disabled v-for="(item_check, key_check) in item.stageTask2" :key="key_check"
                v-model="item_check.isCompleted" shape="square"
                :class="item.learningStatus !== '1' ? 'stat_checked' : ''">{{ item_check.taskName }}
                <span v-if="
                  item_check.completedCount > 0
                ">
                  ：{{ item_check.completedCount }}次
                </span>
              </van-checkbox>
            </van-collapse-item>
            <van-collapse-item title="病例复盘" v-if="item.stageTask1 && item.stageTask1.length > 0"
              :name="`${item.stageName}病例复盘${index}`">
              <van-checkbox disabled v-for="(item_check, key_check) in item.stageTask1" :key="key_check"
                v-model="item_check.isCompleted" shape="square"
                :class="item.learningStatus !== '1' ? 'stat_checked' : ''">{{ item_check.taskName }}
                <span v-if="
                  item_check.completedCount > 0
                ">
                  ：{{ item_check.completedCount }}次
                </span>
              </van-checkbox>
            </van-collapse-item>
            <van-collapse-item title="学术活动" v-if="item.stageActivity && item.stageActivity.length > 0"
              :name="`${item.stageName}学术活动${index}`">
              <van-checkbox disabled v-for="(item_check, key_check) in item.stageActivity" :key="key_check"
                v-model="item_check.isCompleted" shape="square"
                :class="item.learningStatus !== '1' ? 'stat_checked' : ''">{{ item_check.activityName }}
                <span v-if="
                  item_check.completedCount > 0
                ">
                  ：{{ item_check.completedCount }}次
                </span>
              </van-checkbox>
            </van-collapse-item>
            <van-collapse-item title="课程学习" v-if="item.stageCourses && item.stageCourses.length > 0"
              :name="`${item.stageName}课程学习${index}`">
              <van-checkbox disabled v-for="(item_check, key_check) in item.stageCourses" :key="key_check"
                v-model="item_check.isCompleted" shape="square"
                :class="item.learningStatus !== '1' ? 'stat_checked' : ''">{{ item_check.courseDisplayName }}
              </van-checkbox>
            </van-collapse-item>
          </van-collapse>
        </van-collapse-item>
      </van-collapse>
    </div>
    <barComponents v-if="isShowBar"></barComponents>
  </div>
</template>

<script>
import detailData from './index.json'
import { getJourneyReport } from '@/api/growthJourney.js'
import { xwzyJourneyReport } from '@/api/xwzy.js'
import { trackPageView } from '@/utils/trace'
import barComponents from '../../components/barComponents.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'journeyReport',
  components: {
    barComponents
  },
  data () {
    return {
      detail: {},
      activeNum: 0,
      activeNames: [0],
      cur_state: {},
      cur_journey_index: 0,
      curJourneyDetail: {},
      activeCourse: [],
      pathToFrom: {},
      isDouble: false,
      isShowBar: true,
      defaultTime: new Date().getTime(),
    }
  },
  mounted () {
    this.handleGetData()
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    // 跳转此页来源
    tabSource () {
      return this.$route.query.source || ''
    },
    // 跳转此页来源的医生multiCode
    tabMultiCode () {
      return this.$route.query.multiCode || ''
    },
    // 跳转此页来源的医生name
    tabDoctorName () {
      return this.$route.query.doctorName || ''
    },
  },
  destroyed () {
  },
  methods: {
    handleGetData () {
      let code = ''
      if (this.tabSource === 'growth-overview' || this.tabSource === 'xwzy') {
        code = this.tabMultiCode.toString()
      } else {
        code = this.userInfo.multiCode || ''
      }
      if (this.tabSource === 'xwzy') {
        xwzyJourneyReport({
          multiCode: this.code ? this.code : code
        }).then(res => {
          this.handleGetDataDefaut(res)
        })
        return
      }
      if (code) {
        getJourneyReport({
          multiCode: this.code ? this.code : code
        }).then(res => {
          this.handleGetDataDefaut(res)
        })
      } else {
        this.handleGetDataDefaut({data: null})
      }
    },
    handleGetDataDefaut (res) {
      this.detail = res.data // || detailData 默认静态返回
      if (!this.detail && !this.boolReturn) {
        this.code = 'MULD100000793'
        this.boolReturn = true
        this.handleGetData()
        return
      } else if (!this.detail) {
        this.detail = detailData
      }
      // this.isDouble = (this.detail.currentJourneyNo === 'U' && this.detail.currentJourney === '超声视界之旅')
      let count = 0
      this.detail.journeyReports.map((res, index) => {
        if (res.learningStatus === '2') {
          count++
          this.cur_journey_index = index
          // 便利当前旅程下面的阶段赋值为2
          res.stages.map((itemStage, _index) => {
            if (itemStage.stageNo.substring(0, 2) !== 'U4') {
              if (itemStage.stageName === this.detail.currentStage) {
                itemStage.learningStatus = '2'
              }
            }
          })
        }
        this.isDouble = count === 2
      })
      this.detail.currentJourneyStage = this.detail.journeyReports[this.cur_journey_index]
      this.cur_state = this.detail.currentJourneyStage
      this.defaultState()
    },
    defaultState () {
      this.defaultTime = new Date().getTime()
      this.curJourneyDetail = this.detail.journeyReports.filter((res, index) => {
        // 低于当前进行中的旅程的都视为已过关
        if (index < this.cur_journey_index) {
          if ((!this.isDouble && (index !== 1 || index !== 2)) || index === 0) {
            res.learningStatus = '1'
            res.stages.map((itemStage, _index) => {
              itemStage.learningStatus = '1'
            })
          }
        }
        // 如果是双旅程的话，当前最新旅程为进行中
        // if (this.isDouble && res.journeyName === this.detail.latestJourneyName) {
        //   res.learningStatus = '2'
        //   // 便利当前旅程下面的阶段赋值为2
        //   res.stages.map((itemStage, _index) => {
        //     itemStage.learningStatus = '3'
        //     if (itemStage.stageName === this.detail.latestStageName) {
        //       itemStage.learningStatus = '2'
        //     }
        //   })
        // }
        // 赋值低于当前阶段的都归为已过关
        let _i = 10
        for (let i = 0; i < res.stages.length; i++) {
          if (res.stages[i].stageNo.substring(0, 2) !== 'U4') {
            if ((res.stages[i].learningStatus === '2' || res.stages[i].learningStatus === '1')) {
              _i = i
            }
            // if (i > _i && i !== 1) {
            if (i > _i) {
              res.stages[i].learningStatus = '1'
            }
          }
        }
        return res.journeyName === this.detail.currentJourneyStage.journeyName
      })[0]
      this.curJourneyDetail.stages.map((res, index) => {
        res.stageTask1 = res.stageTasks.filter((res) => {
          return res.taskType === '病例复盘'
        })
        res.stageTask2 = res.stageTasks.filter((res) => {
          return res.taskType === '模拟器练习'
        })
        if (this.activeCourse.length > 0) {
          this.activeCourse = this.activeCourse.concat([`${res.stageName}病例复盘${index}`, `${res.stageName}学术活动${index}`, `${res.stageName}课程学习${index}`, `${res.stageName}模拟器练习${index}`])
        } else {
          this.activeCourse = [`${res.stageName}病例复盘${index}`, `${res.stageName}学术活动${index}`, `${res.stageName}课程学习${index}`, `${res.stageName}模拟器练习${index}`]
        }
        if (res.learningStatus === '2') {
          this.activeNames = [index]
          this.detail.currentJourneyStage.currentStage = res
        }
        return res
      })
      setTimeout(() => {
        window.sessionStorage.setItem('traceTitle', `${'旅程报告-' + this.detail.currentJourneyStage.journeyName}`)
      })
    },
    // 选择切换旅程
    async handleChangeJounery (item) {
      window.sessionStorage.setItem('traceTitle', `${'旅程报告-' + this.detail.currentJourneyStage.journeyName}`)
      await trackPageView(this.pathToFrom.to, this.pathToFrom.to, this.defaultTime) // 上报数据
      this.activeNames = [100]
      this.detail.currentJourneyStage =
        this.cur_state.journeyName === item.journeyName
          ? this.cur_state
          : item
      this.detail.currentJourneyStage.stages.map((res) => {
        if (res.learningStatus === 2) {
          this.detail.currentJourneyStage.currentStage = res
        }
      })
      this.defaultState()
    }
  },

}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.page-report {
  background-color: #f0f1f6;
  min-height: 100vh;
  padding-bottom: 60px;
  box-sizing: border-box;

  .img-cover {
    width: 100%;
    height: 141px;
  }

  .block-info {
    padding: 0 12px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      padding-left: 15px;
      position: relative;
      margin-top: 16px;
      margin-bottom: 15px;

      &::before {
        position: absolute;
        left: 5px;
        width: 4px;
        height: 12px;
        border-radius: 4px;
        background-color: #EB1700;
        top: 50%;
        transform: translateY(-50%);
        content: '';
      }
    }

    .block-con {
      background-color: #fff;
      width: 100%;
      border-radius: 8px;
      padding: 17px 24px;
      padding-bottom: 1px;
      box-sizing: border-box;

      .con-info {
        display: flex;
        position: relative;
        margin-bottom: 16px;

        &::before {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #d8d8d8;
          left: -10px;
          top: 7px;
          content: '';
        }

        .label {
          font-size: 12px;
          color: #333333;
          line-height: 17px;
          width: 120px;
        }

        .val {
          font-size: 12px;
          color: #333333;
          width: 200px;
          line-height: 17px;

          &.border {
            width: 58px;
            height: 17px;
            border-radius: 100px;
            border: 1px solid #EB1700;
            text-align: center;
          }
        }
      }
    }
  }

  .block-flex {
    display: flex;
    width: 100%;
    padding-left: 13px;
    box-sizing: border-box;
    overflow-y: auto;
    margin-top: 16px;
    margin-bottom: 12px;

    .flex-nav {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      padding: 0 12px;
      box-sizing: border-box;
      width: 94px;
      height: 74px;
      position: relative;

      &.cur {
        height: 84px;

        .nav-tag-img {
          width: 52px;
          height: 17px;
        }

        .txt {
          color: #fff;
        }
      }

      .nav-tag-img {
        position: absolute;
        width: 44px;
        height: 17px;
        top: 0;
        left: 0;
        z-index: 1;
      }

      .txt {
        width: 71px;
        height: 40px;
        line-height: 20px;
        font-size: 14px;
        color: #EB1700;
        text-align: center;
        position: relative;
      }

      .bg-img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        object-fit: cover;
      }
    }
  }

  .block-level {
    padding: 17px 15px;
    padding-top: 0;
    box-sizing: border-box;

    /deep/ .level-item {
      padding: 16px 15px;
      box-sizing: border-box;
      background-color: #fff;
      margin-bottom: 23px;
      border-radius: 8px;

      .van-cell {
        overflow: visible;
      }

      .col-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #000;

        .report-img {
          position: absolute;
          top: -22px;
          left: 0;
          height: 15px;
          width: auto;
          z-index: 9;
        }

        .state-name {
          margin-right: 6px;
        }
      }

      .van-collapse-item__wrapper {
        padding-left: 30px;
        box-sizing: border-box;
      }

      &::before {
        position: absolute;
        left: 25px;
        border-left: 1px dashed #979797;
        content: '';
        height: calc(100% - 56px);
        top: 40px;
        transform: inherit;
      }

      &.cur_level {
        .van-collapse-item {
          &::before {
            background: linear-gradient(270deg,
                rgba(255, 91, 12, 0) 0%,
                #EB1700 100%) !important;
          }

          .van-checkbox__icon--checked {
            .van-icon {
              background-color: #EB1700;
              border-color: #EB1700;
              color: #EB1700 !important;
              ;
            }
          }

          .van-checkbox__icon--disabled {
            .van-icon {
              border-color: #EB1700;
              background-color: transparent;
            }
          }
        }

        &::after {
          position: absolute;
          left: 0;
          border-left: 7px solid #EB1700;
          content: '';
          height: 100%;
          top: 0;
          transform: inherit;
          border-bottom-left-radius: 8px;
          border-top-left-radius: 8px;
        }
      }

      /deep/ .van-cell__title {
        font-size: 16px;
        color: #000;
        font-weight: 500;
      }

      .level-title {
        display: flex;
        font-size: 12px;
        color: #333333;
        margin-top: 9px;
        margin-bottom: 15px;

        .level-txt {
          margin-right: 10px;

          .img-txt {
            width: 53px;
            height: 19px;
          }
        }

        .icon-title {
          width: 53px;
          height: 20px;
          margin-right: 3px;
        }
      }

      .tip {
        font-size: 12px;
        color: #EB1700;
        margin: 6px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .delay-day {
          display: flex;
          align-items: center;

          .icon-time {
            width: 13px;
            height: 13px;
            margin-right: 6px;
          }
        }
      }

      .level-course {
        border-radius: 2px;
        position: relative;

        .van-cell__title {
          font-size: 12px;
          color: #333333;
        }

        .van-cell {
          background: transparent;
        }

        .van-collapse-item__wrapper {
          padding-left: 0;
        }

        .van-collapse-item {
          margin-bottom: 8px;
          padding: 6px 7px;
          box-sizing: border-box;
          z-index: 9;

          &::before {
            background: linear-gradient(270deg,
                rgba(171, 172, 204, 0.14) 0%,
                #abaccc 100%);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.17;
            z-index: -1;
            content: '';
          }

          &::after {
            border: none;
          }

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .van-collapse-item__content {
            background: transparent;
          }
        }
      }
    }
  }
}

/deep/ .van-cell {
  padding: 0;
}

/deep/ .van-collapse-item__content {
  padding: 0;
}

/deep/ .van-checkbox {
  align-items: center;
  // height: 20px;
  padding: 0;
  box-sizing: border-box;
  margin-top: 14px;

  .van-checkbox__icon--checked {
    .van-icon {
      background-color: #c6cadd;
      border-color: #c6cadd;
    }
  }

  .van-icon,
  .van-checkbox__icon {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    font-size: 10px;
    border-radius: 2px;
  }

  .van-checkbox__label {
    font-size: 12px;
    color: #2b2b2b;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // display: flex;
  }

  &.stat_checked {
    .van-icon {
      border-color: #EB1700;
    }
  }
}

/deep/ .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/journeyReport/journeyReport.vue